import React from 'react';

import { NavigationMenuItem } from 'src/application/features/NavigationMenu/components/student/NavigationMenuItem/NavigationMenuItem';
import { useIntlReexport } from 'src/application/hooks/useIntlReexport';
import { getItemByIdSelector } from 'src/application/store/reducers/items/itemsSelectors';
import { createGetResourcesFolderItemSelector } from 'src/application/store/selectors/getResourcesFolderItem';
import { useStudentSelector } from 'src/application/store/selectors/useStudentSelector';
import { generalMessages } from 'src/translates/generalMessages';

import { ProjectViewModel } from '../../../../../config/configs';
import { StudentViewMode } from '../../../../../config/constants';
import { AdminLayout, Text } from '@ael/shared-components-library';
import { CSSTransition } from 'react-transition-group';

import './HomeOverview.scss';

type HomeOverviewProps = {
  projectViewModel: ProjectViewModel;
  backendUrl: string;
  hideStudentHeader: boolean;
  isInPreview: boolean;
  viewMode: StudentViewMode;
  isVisible: boolean;
};

export const HomeOverview: React.FC<HomeOverviewProps> = (props) => {
  const coverImageAssetGuid = props.projectViewModel.config.homeOverview.coverImageAssetGuid;

  const assetViewModel = coverImageAssetGuid ? props.projectViewModel.assets[coverImageAssetGuid] : null;
  const coverImageUrl = assetViewModel?.downloadUrl;
  const rootMenuItems = useStudentSelector((state) => state.rootItems);
  const getItemById = useStudentSelector(getItemByIdSelector);
  const isLinearModeOn = props.projectViewModel.config.isLinearModeEnabled;
  const resourceFolder = useStudentSelector(createGetResourcesFolderItemSelector);

  const { formatMessage } = useIntlReexport();

  return (
    <CSSTransition in={props.isVisible} timeout={300} classNames="fade" unmountOnExit>
      <div className="uno-fixed uno-w-full uno-h-full uno-inset-0 uno-bg-background uno-z-800">
        <AdminLayout>
          <AdminLayout.Header backgroundImageSrc={coverImageUrl}>
            <AdminLayout.Header.Title>{props.projectViewModel.config.name}</AdminLayout.Header.Title>
          </AdminLayout.Header>
          <AdminLayout.Content>
            <div className="uno-flex uno-flex-col uno-gap-5">
              <div
                className="home-overview__description"
                dangerouslySetInnerHTML={{ __html: props.projectViewModel.config.homeOverview.description }}
              ></div>
              <Text weight="bold" size="l">
                {formatMessage(generalMessages.lessons)}
              </Text>
              <div>
                {rootMenuItems.map((itemId: string) => (
                  <NavigationMenuItem
                    key={itemId}
                    itemId={itemId}
                    parentItemId={null}
                    nestedLevel={0}
                    getItemById={getItemById}
                    isLinearModeOn={isLinearModeOn}
                    isStudent={true}
                  />
                ))}
                {resourceFolder && (
                  <NavigationMenuItem
                    itemId={resourceFolder.id}
                    parentItemId={null}
                    nestedLevel={0}
                    getItemById={getItemById}
                    isLinearModeOn={isLinearModeOn}
                    isStudent={true}
                  />
                )}
              </div>
            </div>
          </AdminLayout.Content>
        </AdminLayout>
      </div>
    </CSSTransition>
  );
};
